/**
 * @description Check if the targeted element is on the same scroll level than the window
 *
 * @param {String} selector CSS selector to target
 */

export default function isScrollTargetVisible(selector) {
  let position = document.querySelector(selector).getBoundingClientRect();
  if(position.top + position.height > 0 && position.top + position.height < window.innerHeight) {
    return true;
  }
  return false;
}
